import * as betgalaxy from './Table.styles.betgalaxy';
import * as betprofessor from './Table.styles.betprofessor';
import * as betroyale from './Table.styles.betroyale';
import * as fiestabet from './Table.styles.fiestabet';
import * as puntcity from './Table.styles.puntcity';
import * as puntgenie from './Table.styles.puntgenie';
import * as questbet from './Table.styles.questbet';
import * as sterlingparker from './Table.styles.sterlingparker';
import * as vikingbet from './Table.styles.vikingbet';
import * as volcanobet from './Table.styles.volcanobet';
import * as juicybet from './Table.styles.juicybet';
import * as goldenrush from './Table.styles.goldenrush';
import * as forsport from './Table.styles.forsport';
import * as junglebet from './Table.styles.junglebet';
import * as sugarcastle from './Table.styles.sugarcastle';
import * as oldgill from './Table.styles.oldgill';
import * as buffalobet from './Table.styles.buffalobet';
import * as titanbet from './Table.styles.titanbet';
import * as slambet from './Table.styles.slambet';
import * as gigabet from './Table.styles.gigabet';
import * as betstride from './Table.styles.betstride';
import * as templebet from './Table.styles.templebet';
import * as goldenbet888 from './Table.styles.goldenbet888';
import * as hyperbet from './Table.styles.hyperbet';
import * as bet777 from './Table.styles.bet777';
import * as chromabet from './Table.styles.chromabet';
import * as bet575 from './Table.styles.bet575';
import * as betblast from './Table.styles.betblast';
import * as pyramidbet from './Table.styles.pyramidbet';
import * as magnumbet from './Table.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  goldenrush,
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  juicybet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  betblast,
  pyramidbet,
  magnumbet,
};
